module.exports = __webpack_public_path__ + "img/lupa.20667c85.svg";